import { useMediaQuery, useTheme } from '@mui/material';

const useDesktopMedia = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  return isDesktop;
};

export default useDesktopMedia;
